import React, { useEffect, useState } from "react";
import cloneDeep from "lodash.clonedeep";
import { FormGroup } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { TYPE_HYBRID } from "../../../constants";
import RegistrationFieldsListItem from "./RegistrationFieldsListItem";

const RegistrationFieldsList = ({
    registrationFields,
    registrationType,
    onUpdateField,
    onUpdateOrder,
}) => {
    const [fields, setFields] = useState([]);

    const participationTypeStyles = registrationType === TYPE_HYBRID ? 'block' : 'none';

    useEffect(() => {
        setFields(registrationFields || [])
    },[registrationFields]);

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const reorderedList = reorder(
            fields,
            result.source.index,
            result.destination.index,
        );

        onUpdateOrder(reorderedList);
    }

    function reorder(list, startIndex, endIndex) {
        const result = cloneDeep(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    return (
        <FormGroup>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {fields?.map((field, index) => (
                                <Draggable
                                    key={field.id}
                                    draggableId={`${field.field.name || index}`}
                                    index={index}
                                    isDragDisabled={field.field.name === 'participationType'}
                                >
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                                ...provided.draggableProps.style,
                                                display: field.field.name === 'participationType'
                                                    ? participationTypeStyles
                                                    : 'block',
                                            }}
                                        >
                                            <RegistrationFieldsListItem
                                                key={field.id}
                                                id={field.id}
                                                name={field.field.label_ru}
                                                label={field.field.name}
                                                type={field.field.type}
                                                isLabelHidden={field.labelHidden}
                                                isPlaceholderHidden={field.placeholderHidden}
                                                onChange={onUpdateField}
                                            />
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </FormGroup>
    );
};

export default RegistrationFieldsList;